/* eslint-disable no-restricted-syntax */
/* eslint-disable no-multi-assign */
/* eslint-disable guard-for-in */
import _ from 'lodash';
import get from 'lodash/get';
import * as configuratorActions from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import * as actionTypes from './Actions';

const initialState = {
  creatorMobileProductsListOpen: false,
  creatorMobileModalContent: null,
  creatorMobileModalContentOptions: {
    RENDER_OVERVIEW: 'RENDER_OVERVIEW',
    RENDER_ITEMMENU: 'RENDER_ITEMMENU',
  },
  // Mehrere States für besseres Handling später, auch wenn das gleiche über einen abbildbar wäre
  creatorInitialOptionClassification: [],
  creatorInitialOptionClassificationIdentifier: {},
  creatorChangedClassifications: {},
};

function CustomReducer(state = initialState, action = {}) {
  switch (action.type) {
    case configuratorActions.RECEIVE_CONFIGURATION: {
      const item = get(action, 'data.item', {});
      let { originalConfigurationData } = initialState;
      if (!originalConfigurationData && action.data) {
        originalConfigurationData = action.data;
      }
      const creatorInitialOptionClassification = get(action, 'data.optionclassifications', {});
      const optionIdentifiers = {};
      creatorInitialOptionClassification.forEach((classification) => {
        optionIdentifiers[classification.identifier] = classification;
        console.log('test', { classification });
        const { is_mandatory, selectedoptions } = classification;
        if (is_mandatory && selectedoptions === null) {
          // TODO ggf default select
        }
      });
      return {
        ...state,
        creatorInitialOptionClassification,
        creatorChangedClassifications: {},
        creatorInitialOptionClassificationIdentifier: optionIdentifiers,
      };
    }
    case configuratorActions.RECEIVE_SWITCHOPTIONSRESULT: {
      const creatorInitialOptionClassification = get(action, 'data.optionclassifications', {});
      const changedList = {};
      let didChange = false;
      creatorInitialOptionClassification.forEach((classification) => {
        if (state.creatorChangedClassifications[classification.identifier]) {
          didChange = true;
        } else {
          didChange = false;
          if (state.creatorInitialOptionClassificationIdentifier[classification.identifier].selectedoptions) {
            if (!classification.is_multiselect) {
              didChange = classification.selectedoptions[0].identifier
            !== state.creatorInitialOptionClassificationIdentifier[classification.identifier].selectedoptions[0].identifier;
            } else {
              classification.selectedoptions.some((option) => {
                didChange = classification.selectedoptions[0].identifier
            !== state.creatorInitialOptionClassificationIdentifier[classification.identifier].selectedoptions[0].identifier;
                return didChange;
              });
            }
          } else {

          }
        }

        changedList[classification.identifier] = didChange;
      });
      return {
        ...state,
        creatorChangedClassifications: changedList,
      };
    }
    case actionTypes.SET_CREATOR_MOBILE_PRODUCTLIST_OPEN: {
      return {
        ...state,
        creatorMobileProductsListOpen: action.value,
      };
    }
    case actionTypes.SET_CREATOR_MOBILE_MODAL_CONTENT: {
      let val = action.value;
      if (!state.creatorMobileModalContentOptions[val]) val = null;
      return {
        ...state,
        creatorMobileModalContent: val,
      };
    }
    default: {
      return state;
    }
  }
}
export default CustomReducer;
